import moment from 'moment';
import { validate } from 'uuid';
import { QueryParamDataType } from '../../constants';
import { defaultDateFormat } from '../../../../../constants';

const isValidDataType = <AcceptedValuesEnum>(type: QueryParamDataType, value: string | null, customEnum?: AcceptedValuesEnum): boolean => {
  if (value) {
    switch (type) {
      case QueryParamDataType.CUSTOM: // Uses a custom enum for more precise validation
        return !!customEnum && Object.values(customEnum).includes(value as keyof AcceptedValuesEnum);
      case QueryParamDataType.DATE:
        return moment(value, defaultDateFormat, true).isValid();
      case QueryParamDataType.UUID:
        return validate(value);
      case QueryParamDataType.NUMBER:
        return !Number.isNaN(Number(value));
      case QueryParamDataType.BOOLEAN:
        return value === 'true' || value === 'false';
      case QueryParamDataType.STRING:
        return value !== '';
      default:
        return false;
    }
  }

  return false;
};

export default isValidDataType;
